import { useSyncExternalStore } from "react";
export type DemoRole = "free" | "pro" | "cap";
export type DemoVideo = {
  id: string;
  url: string;
  status: "pending" | "approved" | "rejected" | "deleted";
  reason?: string;
};
export type DemoWork = {
  id: string;
  opportunityId: string;
  kind: "job" | "campaign";
  status: "offered" | "active" | "completed";
  required: number;
  payout: number;
  deadline: string;
  paid: boolean;
  extensionRequested?: boolean;
  videos: DemoVideo[];
};
type DemoState = {
  work: DemoWork[];
  conversations: Record<string, { body: string; own: boolean }[]>;
  proposals: Record<string, { count: number; rate: number; pitch: string }>;
  role: DemoRole;
  name: string;
  rate: string;
  categories: string[];
  applications: string[];
  saved: string[];
  flashAlerts: boolean;
  discount: string;
  frequency: string;
};
const initial: DemoState = {
  proposals: {},
  conversations: {},
  work: [
    {
      id: "w-serum",
      opportunityId: "serum",
      kind: "job",
      status: "active",
      required: 3,
      payout: 300,
      deadline: "2026-09-16",
      paid: false,
      videos: [
        {
          id: "s1",
          url: "https://www.tiktok.com/@jordancreates/video/7400000000000000001",
          status: "approved",
        },
        {
          id: "s2",
          url: "https://www.tiktok.com/@jordancreates/video/7400000000000000002",
          status: "rejected",
          reason: "Keep the opening demonstration from the reference brief.",
        },
      ],
    },
    {
      id: "w-tonic",
      opportunityId: "tonic",
      kind: "campaign",
      status: "active",
      required: 2,
      payout: 120,
      deadline: "2026-09-21",
      paid: false,
      videos: [],
    },
    {
      id: "w-shampoo",
      opportunityId: "shampoo",
      kind: "job",
      status: "offered",
      required: 5,
      payout: 500,
      deadline: "2026-09-20",
      paid: false,
      videos: [],
    },
    {
      id: "w-cookies",
      opportunityId: "cookies",
      kind: "job",
      status: "completed",
      required: 3,
      payout: 360,
      deadline: "2026-09-01",
      paid: true,
      videos: [1, 2, 3].map((n) => ({
        id: `completed-${n}`,
        url: `https://www.tiktok.com/@jordancreates/video/740000000000000010${n}`,
        status: "approved" as const,
      })),
    },
  ],
  role: "pro",
  name: "Jordan Ellis",
  rate: "1000",
  categories: ["Beauty", "Lifestyle"],
  applications: [],
  saved: [],
  flashAlerts: false,
  discount: "20",
  frequency: "daily",
};
function restore(): DemoState {
  try {
    return {
      ...initial,
      ...JSON.parse(sessionStorage.getItem("bmc-coach-portal-demo") || "{}"),
    };
  } catch {
    return initial;
  }
}
let state = restore();
const listeners = new Set<() => void>();
export function setDemo(patch: Partial<DemoState>) {
  state = { ...state, ...patch };
  try {
    sessionStorage.setItem("bmc-coach-portal-demo", JSON.stringify(state));
  } catch {}
  listeners.forEach((fn) => fn());
}
export function resetDemo() {
  try {
    localStorage.removeItem("bmc-connector-confirmed:demo");
    sessionStorage.removeItem("bmc-demo-onboarding-complete");
  } catch {}
  setDemo(initial);
}
export function getDemo() {
  return state;
}
export function useDemo() {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => state,
  );
}
